import moment from 'moment-timezone'
import * as type from './constant';

const currentMonth = moment.tz('Asia/Makassar').format('YYYY-MM');

const initialState = {
  dataTask: [],
  monthTask: currentMonth,

  updatedTask: null,
  addedTask: null,
  deletedTask: null,

  loading: false,
  loadingManipulation: false,
  error: null,
  errorManipulation: null,
};
export default (state = initialState, action) => {

  switch (action.type) {

    case type.GET:
      return {
        ...state,
        updatedTask: null,
        addedTask: null,
        deletedTask: null,
        loading: true,
        loadingManipulation: false,
        error: null,
        errorManipulation: null,
      };

    case type.GET_SUCCESS:
      return {
        ...state,
        [`dataTask${action.selfRole}`]: [...action.payload],
        [`monthTask${action.selfRole}`]: action.month,
        loading: false,
      };

    case type.GET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case type.ADD:
      return {
        ...state,
        addedTask: null,
        loadingManipulation: true,
        errorManipulation: null,
      };

    case type.ADD_SUCCESS:
      return {
        ...state,
        addedTask: action.payload,
        loadingManipulation: false,
      };

    case type.UPDATE:
      return {
        ...state,
        updatedTask: null,
        loadingManipulation: true,
        errorManipulation: null,
      };

    case type.UPDATE_SUCCESS:
      return {
        ...state,
        updatedTask: action.payload,
        loadingManipulation: false,
      };

    case type.DELETE:
      return {
        ...state,
        deletedTask: null,
        loadingManipulation: true,
        errorManipulation: null,
      };

    case type.DELETE_SUCCESS:
      return {
        ...state,
        deletedTask: action.payload,
        loadingManipulation: false,
      };

    case type.CANCEL:
      return {
        ...state,
        updatedTask: null,
        loadingManipulation: true,
        errorManipulation: null,
      };

    case type.CANCEL_SUCCESS:
      return {
        ...state,
        updatedTask: action.payload,
        loadingManipulation: false,
      };

    case type.CANCEL_ASIGNEE:
      return {
        ...state,
        updatedTask: null,
        loadingManipulation: true,
        errorManipulation: null,
      };

    case type.CANCEL_ASIGNEE_SUCCESS:
      return {
        ...state,
        updatedTask: action.payload,
        loadingManipulation: false,
      };

    case type.MANIPULATION_ERROR:
      return {
        ...state,
        loadingManipulation: false,
        errorManipulation: action.error,
      };

    default:
      return state;
  }
};
